import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var PlanIcon = function PlanIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e, _f;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    strokeColor = _props.strokeColor,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.3 17.3",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("path", {
    fill: fillColor,
    stroke: (_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : strokeColor,
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-linejoin": "".concat((_e = attrs["stroke-linejoin"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-width": "".concat((_f = attrs["stroke-width"]) !== null && _f !== void 0 ? _f : "1"),
    "d": "M16.65 13.983a2.667 2.667 0 0 1-2.666 2.667H3.317A2.667 2.667 0 0 1 .65 13.983V3.316A2.666 2.666 0 0 \n            1 3.317.65h10.667a2.666 2.666 0 0 1 2.666 2.666v6.217m-9.244-.054H.657m6.852-4.461V1.379m0 11.675V8.787"
  })]);
};